import React from "react";

export const MerchantAgreementTemplate = ({ businessData }) => (
  <div
    style={{
      padding: "20px",
      //   fontFamily: "Times New Roman, serif",
      fontSize: "16px",
      lineHeight: "1.4",
      color: "#000",
      backgroundColor: "#fff",
      width: "100%",
    }}
  >
    {/* Header */}
    <div style={{ textAlign: "center", marginBottom: "30px" }}>
      <div style={{ display: "flex", justifyContent: "start" }}>
        <img
          src="../images/business_registration.PNG"
          alt="terms and conditions"
          style={{
            width: "",
            height: "7vh",
            borderRadius: "12px",
          }}
        />
      </div>
      <h1
        style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "20px" }}
      >
        MERCHANT AGREEMENT
      </h1>
      <div
        style={{
          backgroundColor: "#f0f8ff",
          padding: "15px",
          border: "2px solid #4169E1",
          borderRadius: "8px",
          fontSize: "14px",
          fontWeight: "bold",
        }}
      >
        "This Agreement with Greggii Inc. "Myooo" is completely risk-free. There
        are no upfront costs, hidden fees, or surprise charges; Merchant gets
        free marketing and exposure, and the Merchant only pays 25% commission
        plus payment processing fees 2.99% and 30 Cents after a successful
        sale."
      </div>
    </div>

    {/* Agreement Parties */}
    <div style={{ marginBottom: "25px", textAlign: "justify" }}>
      <p style={{ marginBottom: "15px" }}>
        This Merchant Agreement ("Agreement") is entered into as of
        <strong> {businessData.currentDate}</strong> by and between:
      </p>
      <p style={{ marginBottom: "10px" }}>
        <strong>Greggii Inc.</strong>, a Delaware corporation, with principal
        place of business at 28210 Paseo Drive #190-231 Wesley Chapel, FL 33543
        "Myooo" ("Platform"), and
      </p>
      <p style={{ marginBottom: "10px" }}>
        <strong>{businessData.businessName}</strong>, with principal place of
        business at
        <strong> {businessData.location.address}</strong> ("Merchant").
      </p>
      <p>
        Platform and Merchant are each a "Party" and together the "Parties."
      </p>
    </div>

    {/* Section 1: Definitions */}
    <div style={{ marginBottom: "20px" }}>
      <h3
        style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "10px" }}
      >
        1. Definitions
      </h3>
      <ul style={{ paddingLeft: "20px", marginBottom: "0" }}>
        <li style={{ marginBottom: "8px" }}>
          <strong>"Deal"</strong> means a promotional offer (coupon, discount,
          bundle, package) marketed by Platform on behalf of Merchant as
          specified in a Deal Addendum.
        </li>
        <li style={{ marginBottom: "8px" }}>
          <strong>"Gross Sales"</strong> means total amount paid by customers
          for vouchers related to a Deal, before refunds, taxes, payment
          processing fees and Platform's share.
        </li>
        <li style={{ marginBottom: "8px" }}>
          <strong>"Net Proceeds"</strong> means Gross Sales less refunds,
          credit-card fees, and taxes as defined in Section 5.
        </li>
      </ul>
    </div>

    {/* Section 2: Appointment & Scope */}
    <div style={{ marginBottom: "20px" }}>
      <h3
        style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "10px" }}
      >
        2. Appointment & Scope
      </h3>
      <p style={{ textAlign: "justify" }}>
        Merchant grants Platform the non-exclusive right to market and sell
        Deals for Merchant in the Territory specified in each Deal Addendum.
        Platform will use reasonable efforts to promote Deals through its email
        list, mobile app, website and partner channels.
      </p>
    </div>

    {/* Section 3: Deal Addendum */}
    <div style={{ marginBottom: "20px" }}>
      <h3
        style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "10px" }}
      >
        3. Deal Addendum
      </h3>
      <p style={{ textAlign: "justify" }}>
        Each Deal will be set out in a separate Deal Addendum (electronic form)
        that becomes part of this Agreement and will specify: Deal description,
        retail value, discounted price, quantity/limit, valid redemption period,
        redemption process, and any blackout dates.
      </p>
    </div>

    {/* Section 4: Merchant Responsibilities */}
    <div style={{ marginBottom: "20px" }}>
      <h3
        style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "10px" }}
      >
        4. Merchant Responsibilities
      </h3>
      <p style={{ marginBottom: "8px" }}>Merchant will:</p>
      <ul style={{ paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          Honor vouchers redeemed in accordance with the Deal Addendum.
        </li>
        <li style={{ marginBottom: "5px" }}>
          Provide accurate information about merchant location(s), hours,
          service description, restrictions, and redemption process.
        </li>
        <li style={{ marginBottom: "5px" }}>
          Maintain adequate staff/inventory and timely fulfill valid
          redemptions.
        </li>
        <li style={{ marginBottom: "5px" }}>
          Provide Platform with necessary logos, images, and service
          information.
        </li>
      </ul>
    </div>

    {/* Section 5: Payment Terms */}
    <div style={{ marginBottom: "20px" }}>
      <h3
        style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "10px" }}
      >
        5. Payment Terms
      </h3>
      <ul style={{ paddingLeft: "20px" }}>
        <li style={{ marginBottom: "8px", textAlign: "justify" }}>
          Platform will retain 25% of Net Proceeds (the "Platform Fee") as its
          fee for marketing and payment facilitation. Merchant receives the
          remainder (the "Merchant Share"). Platform could pass any portion of
          the Platform Fee to its users at its sole discretion.
        </li>
        <li style={{ marginBottom: "8px", textAlign: "justify" }}>
          Platform will remit Merchant Share on a weekly basis, subject to
          reconciliation for refunds, chargebacks or fraudulent redemptions.
          Payment will be made by ACH / wire / check / other to Merchant's
          designated account. Merchant must complete payment information in the
          Portal.
        </li>
        <li style={{ marginBottom: "8px", textAlign: "justify" }}>
          Platform may offset funds for refunds, chargebacks, or breaches by
          Merchant under Section 10.
        </li>
      </ul>
    </div>

    {/* Continue with remaining sections... */}
    {/* Sections 6-17 would follow the same pattern */}

    {/* Section 18: Electronic Signatures */}
    <div style={{ marginBottom: "30px" }}>
      <h3
        style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "10px" }}
      >
        18. Electronic Signatures
      </h3>
      <p style={{ textAlign: "justify" }}>
        Merchant agrees that this Agreement may be executed electronically and
        that electronic signatures are the legal equivalent of handwritten
        signatures, to the fullest extent permitted by applicable law.
      </p>
      <p style={{ marginTop: "15px", fontWeight: "bold" }}>
        By selecting Agree & Accept, Merchant affirms it is authorized to enter
        this Agreement and agrees to all terms.
      </p>
    </div>

    {/* Digital Signature Section */}
    <div
      style={{
        borderTop: "2px solid #000",
        paddingTop: "20px",
        pageBreakInside: "avoid",
      }}
    >
      <h3
        style={{ fontSize: "16px", marginBottom: "20px", textAlign: "center" }}
      >
        MERCHANT SIGNATURE
      </h3>

      <div
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "30px" }}
      >
        <div>
          <div style={{ marginBottom: "15px" }}>
            <strong>Merchant Legal Name:</strong>
            <div
              style={{
                borderBottom: "1px solid #000",
                padding: "10px 5px",
                marginTop: "5px",
                minHeight: "25px",
              }}
            >
              {businessData.businessName}
            </div>
          </div>

          <div style={{ marginBottom: "15px" }}>
            <strong>Merchant Email:</strong>
            <div
              style={{
                borderBottom: "1px solid #000",
                padding: "10px 5px",
                marginTop: "5px",
                minHeight: "25px",
              }}
            >
              {businessData.email}
            </div>
          </div>

          <div style={{ marginBottom: "15px" }}>
            <strong>Merchant Phone:</strong>
            <div
              style={{
                borderBottom: "1px solid #000",
                padding: "10px 5px",
                marginTop: "5px",
                minHeight: "25px",
              }}
            >
              {businessData.phoneNumber}
            </div>
          </div>
        </div>

        <div>
          <div style={{ marginBottom: "15px" }}>
            <strong>Authorization Name:</strong>
            <div
              style={{
                borderBottom: "1px solid #000",
                padding: "10px 5px",
                marginTop: "5px",
                minHeight: "25px",
              }}
            >
              {businessData.authorizedName}
            </div>
          </div>
          <div style={{ marginBottom: "15px" }}>
            <strong>Date:</strong>
            <div
              style={{
                borderBottom: "1px solid #000",
                padding: "10px 5px",
                marginTop: "5px",
                minHeight: "25px",
              }}
            >
              {businessData.currentDate}
            </div>
          </div>

          <div style={{ marginBottom: "15px" }}>
            <strong>Digital Signature:</strong>
            <div
              style={{
                borderBottom: "1px solid #000",
                padding: "10px 5px",
                marginTop: "5px",
                minHeight: "25px",
                fontStyle: "italic",
                textAlign: "center",
              }}
            >
              Electronically Signed
            </div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "20px" }}>
        <strong>Merchant Address:</strong>
        <div
          style={{
            borderBottom: "1px solid #000",
            padding: "10px 5px",
            marginTop: "5px",
            minHeight: "25px",
          }}
        >
          {businessData.location.address}
          <br />
          {businessData.location.cityName}, {businessData.location.stateName},{" "}
          {businessData.location.countryName}
        </div>
      </div>

      <div
        style={{
          marginTop: "30px",
          fontSize: "10px",
          textAlign: "center",
          color: "#666",
        }}
      >
        <p>
          Document ID: MA-{Date.now()}-
          {businessData.businessName
            .replace(/\s+/g, "")
            .substring(0, 8)
            .toUpperCase()}
          <br />
          Generated: {businessData.currentDate} | Platform: Myooo by Greggii
          Inc.
        </p>
      </div>
    </div>
  </div>
);
